/* =====================================================================
   Emir ICE — correctifs maison (chargé sur toutes les pages)

   PROBLÈME TRAITÉ : sur la page « bijou sur mesure », les photos envoyées
   par le client arrivaient parfois sous forme de fichier illisible.

   Trois causes réelles, trois correctifs :

   1) Le champ fichier portait name="contact[Fichiers joints]". Le formulaire
      de contact Shopify n'accepte AUCUNE pièce jointe : seul le NOM du
      fichier partait, d'où la ligne « Fichiers joints : IMG_1234.HEIC »
      impossible à ouvrir dans l'e-mail. On retire l'attribut name.

   2) Les photos d'iPhone sont en HEIC et pèsent 8 à 30 Mo : l'hébergeur
      d'images les refusait ou expirait. On ré-encode chaque photo en JPEG
      1920 px directement dans le navigateur, AVANT tout envoi (une photo de
      12 Mo tombe à ~300 Ko), en remplaçant le contenu du champ fichier.

   3) Un échec réseau ponctuel n'était pas réessayé. On ajoute jusqu'à trois
      tentatives d'envoi.
   ===================================================================== */
(function () {
  var MAX_DIM = 1920;
  var QUALITY = 0.86;
  var RETRIES = 3;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ------------------------------------------------------------------
     1. Le champ fichier ne doit jamais être posté vers Shopify
     ------------------------------------------------------------------ */
  function unnameFileInputs() {
    var inputs = document.querySelectorAll('input[type="file"][name^="contact["]');
    Array.prototype.forEach.call(inputs, function (el) { el.removeAttribute('name'); });
  }

  /* ------------------------------------------------------------------
     2. Ré-encodage JPEG des photos choisies
     ------------------------------------------------------------------ */
  function reencode(file) {
    return new Promise(function (resolve) {
      if (!file || !file.type || file.type.indexOf('image') !== 0) { resolve(file); return; }
      if (!window.URL || !window.HTMLCanvasElement) { resolve(file); return; }

      var objectUrl = URL.createObjectURL(file);
      var img = new Image();

      img.onload = function () {
        try {
          var w = img.naturalWidth || img.width;
          var h = img.naturalHeight || img.height;
          if (!w || !h) { URL.revokeObjectURL(objectUrl); resolve(file); return; }

          var ratio = Math.min(1, MAX_DIM / Math.max(w, h));
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(w * ratio);
          canvas.height = Math.round(h * ratio);
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(function (blob) {
            URL.revokeObjectURL(objectUrl);
            if (!blob || !blob.size) { resolve(file); return; }
            var base = (file.name || 'photo').replace(/\.[^.]+$/, '');
            try {
              resolve(new File([blob], base + '.jpg', { type: 'image/jpeg', lastModified: Date.now() }));
            } catch (e) {
              resolve(file);
            }
          }, 'image/jpeg', QUALITY);
        } catch (e) {
          URL.revokeObjectURL(objectUrl);
          resolve(file);
        }
      };

      img.onerror = function () { URL.revokeObjectURL(objectUrl); resolve(file); };
      img.src = objectUrl;
    });
  }

  function normalise(input) {
    if (!input || input.__emirBusy || !input.files || !input.files.length) { return; }
    if (typeof DataTransfer === 'undefined' || typeof File === 'undefined') { return; }

    var files = Array.prototype.slice.call(input.files);
    var needed = files.some(function (f) {
      return f.type.indexOf('image') === 0 && (f.type !== 'image/jpeg' || f.size > 1200000);
    });
    if (!needed) { return; }

    input.__emirBusy = true;
    var form = input.form || (input.closest ? input.closest('form') : null);
    var btn = form ? form.querySelector('.ejr-submit, [type="submit"]') : null;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Optimisation des photos…'; }

    Promise.all(files.map(reencode)).then(function (out) {
      try {
        var dt = new DataTransfer();
        out.forEach(function (f) { dt.items.add(f); });
        input.files = dt.files;
      } catch (e) { /* on garde les fichiers d'origine */ }

      input.__emirBusy = false;
      if (btn) { btn.disabled = false; btn.textContent = label; }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function bind() {
    unnameFileInputs();
    var input = document.getElementById('ejrFiles');
    if (!input || input.__emirBound) { return; }
    input.__emirBound = true;

    input.addEventListener('change', function () { normalise(input); });

    var dz = document.getElementById('ejrDropzone');
    if (dz) {
      dz.addEventListener('drop', function () { setTimeout(function () { normalise(input); }, 60); });
    }
  }

  ready(bind);
  window.addEventListener('load', bind);
  if (window.InstantClick && window.InstantClick.on) { window.InstantClick.on('change', bind); }

  /* ------------------------------------------------------------------
     3. Nouvelles tentatives sur l'envoi des photos
     ------------------------------------------------------------------ */
  function pause(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function install() {
    if (typeof window.fetch !== 'function' || window.fetch.__emirPatched) { return; }
    var delegate = window.fetch;

    var patched = function (resource, options) {
      var url = (typeof resource === 'string') ? resource : (resource && resource.url);
      if (!url || url.indexOf('api.imgbb.com') === -1) {
        return delegate.apply(window, arguments);
      }
      var tries = RETRIES;
      var run = function () {
        return delegate.call(window, resource, options).then(function (res) {
          if (res && res.ok) { return res; }
          if (--tries > 0) { return pause(1200).then(run); }
          return res;
        }).catch(function (err) {
          if (--tries > 0) { return pause(1200).then(run); }
          throw err;
        });
      };
      return run();
    };

    patched.__emirPatched = true;
    window.fetch = patched;
  }

  install();
  window.addEventListener('load', install);
  setTimeout(install, 3000);
})();
